import { Injectable, inject } from '@angular/core';
import { WINDOW } from 'ngx-unificator/tokens';

@Injectable({
  providedIn: 'root'
})
export class WindowService {
  private _window = inject<Window>(WINDOW);


  private _isIphoneDevices: boolean;
  private _isSafari: boolean;

  constructor() {
    this._isIphoneDevices = this._isDetectOs(/ipad|iphone|ipod/i);
    this._isSafari = this._isDetectOs(/^((?!chrome|android).)*safari/i);
  }

  get nativeWindow(): Window {
    return this._window;
  }

  get isIphoneDevices() {
    return this._isIphoneDevices;
  }

  get isSafari() {
    return this._isSafari;
  }

  /**
   * Return true if application runs on specific OS
   *
   * @private
   */
  private _isDetectOs(regexp: RegExp): boolean {
    return regexp.test(this._window.navigator.userAgent) || (!!this._window.navigator.platform && regexp.test(this._window.navigator.platform));
  }
}
